<template>
  <div>
    <vxe-grid
      ref="table"
      auto-resize
      round
      highlight-hover-row
      :height="tableHeight"
      :data="tableData"
      :columns="tableColumn"
      :loading="loading"
      :seq-config="{}"
    >
      <template v-slot:defaultImgUrl="{ row }">
        <div v-viewer="{ movable: true }">
          <el-image
            :src="
              row.scmImageUrl
                ? $osscdn(row.scmImageUrl)
                : '/image/static/img/nopic.jpg'
            "
            style="width:100px; height:66px"
          >
            <div slot="error" class="image-slot">
              <img
                src="/image/static/img/nopic.jpg"
                style="width: 100px; height: 66px"
              />
            </div>
          </el-image>
        </div>
      </template>
      <template v-slot:uploadByImgUrl="{ row }">
        <b-avatar :src="row.memImgUrl ? $osscdn(row.memImgUrl) : ''"></b-avatar>
        <span class="ml-3">{{ row.userNameEn }}</span>
      </template>
      <template v-slot:opt="{ row }">
        <el-tooltip effect="dark" content="查看说明" placement="top">
          <i
            style="font-size:30px"
            class="el-icon-view"
            @click="showEdit(row)"
          ></i>
        </el-tooltip>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">暂无数据！</p>
        </div>
      </template>
    </vxe-grid>
    <!--编辑弹框-->
    <el-dialog
      ref="editDialog"
      :visible.sync="dialogEditFormVisible"
      :before-close="closeEditForm"
      :close-on-click-modal="false"
      width="550px"
    >
      <el-row :gutter="20">
        <el-col>
          <el-form ref="formData">
            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item label="图片说明">
                  <el-input
                    disabled
                    v-model="curScmImageDesc"
                    maxlength="100"
                    type="textarea"
                    :autosize="{ minRows: 3, maxRows: 3 }"
                    show-word-limit
                    size="medium"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" @click="closeEditForm"> 关闭 </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    scmCode: {
      type: String,
      default: () => null
    },
    visitCode: {
      type: String,
      default: () => null
    }
  },
  data() {
    return {
      loading: false,
      dialogEditFormVisible: false,
      dialogUploadFormVisible: false,
      tableHeight: 585,
      tableData: [],
      tableColumn: [
        {
          field: 'seq',
          width: 60,
          align: 'center',
          type: 'seq'
        },
        {
          field: 'scmImageUrl',
          width: 150,
          title: '图片',
          slots: { default: 'defaultImgUrl' }
        },
        {
          field: 'uploadByName',
          width: 180,
          title: '上传人',
          slots: { default: 'uploadByImgUrl' }
        },
        {
          field: 'createTime',
          width: 170,
          title: '上传时间'
        },
        {
          field: 'scmImageDesc',
          minWidth: 200,
          title: '说明'
        },
        {
          field: 'col-opt',
          title: '操作',
          align: 'center',
          width: 140,
          slots: {
            default: 'opt'
          }
        }
      ],
      curScmInfoImageCode: '',
      curScmImageDesc: ''
    }
  },
  watch: {
    visitCode: {
      handler() {
        this.loadData()
      },
      deep: true,
      immediate: true
    },
    scmCode: {
      handler() {
        this.loadData()
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    //加载数据
    loadData() {
      this.loading = true
      let params = {
        scmCode: this.scmCode,
        visitCode: this.visitCode
      }

      this.$api
        .opaScmImageListPageApi(params)
        .then((res) => {
          this.loading = false
          this.tableData = res.body.data
        })
        .catch(() => {
          this.loading = false
        })
    },
    showEdit(row) {
      this.curScmInfoImageCode = row.scmInfoImageCode
      this.curScmImageDesc = row.scmImageDesc
      this.dialogEditFormVisible = true
    },
    // updateDesc() {
    //   this.loading = true
    //   let params = {
    //     scmInfoImageCode: this.curScmInfoImageCode,
    //     scmImageDesc: this.curScmImageDesc,
    //   }
    //   this.$api
    //     .scmInfoUpdateImageDescApi(params)
    //     .then(() => {
    //       this.loading = false
    //       this.dialogEditFormVisible = false
    //       this.reload()
    //     })
    //     .catch(() => {
    //       this.loading = false
    //     })
    // },
    closeEditForm() {
      this.dialogEditFormVisible = false
    }
  }
}
</script>
<style lang="scss" scoped>
.fabric-tree {
  height: 550px;
  overflow-y: auto;
  &::-webkit-scrollbar {
    width: 10px; /*滚动条宽度*/
  }
}
</style>
